import { MaterialIcon, Horizontal, GraviButton } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import type { ActionButtonsProps } from '../types'

/**
 * Component for rendering action buttons in the point-to-point grid
 */
export function ActionButtons({ data, onEdit, onViewRateHistory }: ActionButtonsProps) {
  if (!data) return null

  return (
    <Horizontal
      gap={4}
      style={{
        display: 'flex',
        justifyContent: 'center',
        overflow: 'visible',
      }}
    >
      <Tooltip title='Edit'>
        <GraviButton
          icon={<MaterialIcon size={16} className='pt-1' icon='edit' />}
          onClick={(e) => {
            e.stopPropagation()
            onEdit(data)
          }}
        />
      </Tooltip>
      <Tooltip title='View Rate History'>
        <GraviButton
          icon={<MaterialIcon size={16} className='pt-1' icon='overview' />}
          onClick={(e) => {
            e.stopPropagation()
            onViewRateHistory(data)
          }}
        />
      </Tooltip>
    </Horizontal>
  )
}
